import PropTypes from 'prop-types';
import { ActionButton, PrimaryButton, SecondaryButton } from '@sb1/ffe-buttons-react';

import style from './confirm-modal.module.less';

const ConfirmModalButton = (props) => {
    const { title, type, onClick } = props;
    if (type === 'cancel') {
        return (
            <SecondaryButton className={style.cancelButton} onClick={onClick}>
                {title}
            </SecondaryButton>
        );
    } else if (type === 'action') {
        return (
            <ActionButton className={style.confirmModalButton} onClick={onClick}>
                {title}
            </ActionButton>
        );
    } else {
        return (
            <PrimaryButton className={style.confirmModalButton} onClick={onClick}>
                {title}
            </PrimaryButton>
        );
    }
};
ConfirmModalButton.propTypes = {
    type: PropTypes.oneOf(['cancel', 'success']).isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ConfirmModalButton;
